export default __webpack_public_path__ + "static/2328-c509afc4f2c36c92c8e275a16c524392.gif";